import '../../components/geolocDistance/geolocDistance.css';
import { genericTooltip } from '../../components/genericTooltip/genericTooltip';

export const geoloc = {
  /*
    * init / memorize / location / getUserLocation
    *
    * handle user location via navigator
    * memorize user location in a cookie if geolocation is authorized
    *
  */
  init(triggeredAcceptFunction, triggeredDenyFunction) {
    this.acceptGeolocationFunction = false;
    this.denyGeolocationFunction = false;

    if (triggeredAcceptFunction) {
      this.acceptGeolocationFunction = triggeredAcceptFunction;
    }

    if (triggeredDenyFunction) {
      this.denyGeolocationFunction = triggeredDenyFunction;
    }

    if (navigator.geolocation && cookieManagement.getCookie('userLocation') === null) {
      navigator.geolocation.getCurrentPosition(this.memorize, this.erase);
    }

    //A CONSERVER POUR SIMULER LA GEOLOC EN LOCAL
    // cookieManagement.eraseCookie('userLocation');
    // cookieManagement.createCookie('userLocation', JSON.stringify({'lat':40.123,'long':5.56}), 365);
    // console.log('cookie userLocation main', cookieManagement.getCookie('userLocation'));
  },
  memorize(position) {
    const geoLocation = {
      lat: position.coords.latitude,
      long: position.coords.longitude
    };

    cookieManagement.createCookie('userLocation', JSON.stringify(geoLocation), 365);
    cookieManagement.eraseCookie('userDenyLocation');

    if (typeof geoloc.acceptGeolocationFunction === 'function') {
      geoloc.acceptGeolocationFunction();
      geoloc.acceptGeolocationFunction = false;
    }
  },
  erase(error) {
    if (error.code === 1) {
      cookieManagement.createCookie('userDenyLocation', true);
    }
    cookieManagement.eraseCookie('userLocation');

    if (typeof denyGeolocationFunction === 'function') {
      denyGeolocationFunction();
      denyGeolocationFunction = false;
    }
  },
  /**
   * Get user location lat and lng
   * @return {{lat: number, long: number}|false}
 */
  getUserLocation() {
    /* Check if browsers supports geolocation and if user hasn't already refused it */
    const geoLocDisabled = typeof navigator.geolocation === 'undefined' || cookieManagement.getCookie('userDenyLocation') === 'true';

    /* Try to get user location stored in cookie if it exists */
    const userLocationCookie = cookieManagement.getCookie('userLocation');
    const userPosition = geoLocDisabled ? false : (userLocationCookie === null ? false : JSON.parse(userLocationCookie));

    /* return data or not */
    return !geoLocDisabled && userPosition ? userPosition : false;
  },
  distance: {
    selectors: {
      trigger: '.js-geolocDistance',
      labels: '.js-geolocDistance-label'
    },
    model: null,
    trackingData: {
      clickCode: 'clickMainSearch',
      gaCategory: PAGE_SCRIPTS.page_template,
      gaAction: 'Facette Country Site toggler',
      gaLabel: 'Show my distance',
      event: 'clickEvent'
    },
    init(model) {
      this.model = model;

      /* Check if browsers supports geolocation and if user hasn't already refused it */
      const geolocNotSupport = typeof navigator.geolocation === 'undefined',
        permissionNotSupport = typeof navigator.permissions === 'undefined';
      this.userPosition = geoloc.getUserLocation();

      if (geolocNotSupport) {// si la Geoloc n'est pas supporté on supprime le bouton "afficher les distances"
        $(this.selectors.trigger).parent().remove();
      }
      else if (!geolocNotSupport) { //si la geoloc est supporté on lance initEvent()
        this.initEvent();
        if (!permissionNotSupport) { // si la permission est supporté  alors on ecoute le changement de permission
          navigator.permissions
            .query({ name: 'geolocation' })
            .then((permissionStatus) => {
              permissionStatus.onchange = () => {
                if (permissionStatus.state === 'prompt') {// si l'utilisateur réinitialise la permission ('prompt') --> on supprime tous les cookies (sauf 'userLocation') pour reinit
                  cookieManagement.eraseCookie('userDenyLocation');
                  cookieManagement.eraseCookie('userHideLocation');
                  this.hideDistanceLabel();
                } else if (permissionStatus.state === 'denied') {// si l'utilisateur refuse la permission ('denied')--> on set le cookie userDenyLocation
                  cookieManagement.createCookie('userDenyLocation', true);
                  $('.searchForm-distance').addClass('is-disabled js-priceTooltip-toggle');
                  this.hideDistanceLabel();
                } else {
                  cookieManagement.createCookie('userHideLocation', false);
                  cookieManagement.eraseCookie('userDenyLocation');
                  $('.searchForm-distance').removeClass('is-disabled');
                }
              };
            });
        }
      }
    },
    initEvent() {
      const $document = $(document),
        $button = $(this.selectors.trigger),
        geoLocDisabled = typeof navigator.geolocation === 'undefined' || cookieManagement.getCookie('userDenyLocation') === 'true',
        geoLocIsHidden = cookieManagement.getCookie('userHideLocation') === 'true';

      // show hide default state
      if (geoLocIsHidden || geoLocDisabled) {
        this.hideDistanceLabel();
      } else if (!geoLocDisabled && !!this.userPosition){
        this.showDistanceLabel();
      }

      if (!$button.length) {
        return;
      }

      /* Geolocation non supportée ou non autorisée ? Désactiver ou activer le bouton visuellement en fonction grâce à "disabled" */
      $button.toggleClass('is-disabled', geoLocDisabled);

      /* Reset click listener on button if already set by a previous init() call */
      const event_user = 'click.geolocDomain';
      $document.off(event_user, this.selectors.trigger);

      $document.on(event_user, this.selectors.trigger, (e) => {
        const geoLocDisabledByUser = cookieManagement.getCookie('userDenyLocation') === 'true';

        if (!geoLocDisabledByUser) {
          e.preventDefault();
          const distanceIsHidden = cookieManagement.getCookie('userHideLocation') === 'true';

          if (!geoLocDisabled) {
            if (this.userPosition && distanceIsHidden) {
              dispatcher.trigger('search:resultList:sort', {'sort': 'distance','order': 'desc'});
              $('.js-sortResult-label').html($('.js-sortResult-item[data-sort="distance"]').html());
              this.showDistanceLabel();
            } else {
              dispatcher.trigger('search:resultList:sort', {'sort': 'popularity','order': 'asc'});
              $('.js-sortResult-label').html($('.js-sortResult-item[data-sort="popularity"]').text());
              this.hideDistanceLabel();
            }
            Tracking.dataLayerPush($.extend(geoloc.distance.trackingData, {
              gaLabel: distanceIsHidden ? 'Show my distance' : 'Hide my distance'
            }));
          }
        } else {
          this.showTooltipAndDisable();
        }
      });

      if (!geoLocDisabled && !this.userPosition) {
        /* Init click listener on button to ask user location before load & display datas */
        $document.on(event_user, this.selectors.trigger, (e) => {
          e.preventDefault();
          geoloc.init(() => {
            /* L'utilisateur a autorisé : on affiche les distances */
            this.showDistanceLabel();

            // re-render facet
            this.refresh();
          }, () => {
            /* L'utilisateur a refusé : on affiche la tooltip par-dessus le bouton */
            this.showTooltipAndDisable();
          });
        });
      } else if (geoLocDisabled || !this.userPosition) {
        /* La geoloc a déjà été refusée ou n'est pas supportée par le navigateur : au clic sur l'onglet, on affiche la tooltip par-dessus le bouton */
        $document.on(event_user, this.selectors.trigger, (e) => {
          e.preventDefault();
          this.showTooltipAndDisable();

          if (typeof geolocDistance !== 'undefined' && typeof geolocDistance.trackingData !== 'undefined') {
            //fix erreur js geolocDistance undefined
            Tracking.dataLayerPush($.extend(geolocDistance.trackingData, {
              gaLabel: 'Button not clickable'
            }));
          } else {
            Tracking.dataLayerPush({
              gaLabel: 'Button not clickable'
            });
          }
        });
      }
    },

    hideDistanceLabel() {
      $(this.selectors.trigger).removeClass('is-active');
      $(this.selectors.labels).addClass('u-Hidden--forced');
      cookieManagement.createCookie('userHideLocation', true);
    },
    showDistanceLabel() {
      $(this.selectors.trigger).addClass('is-active');
      $(this.selectors.labels).removeClass('u-Hidden--forced');
      cookieManagement.eraseCookie('userHideLocation');
    },
    showTooltipAndDisable() {
      const $item = $(this.selectors.trigger);
      const wordings = SEARCH_SCRIPTS.WORDING_SEARCH;
      const tooltipId = 'geolocTooltip';

      this.hideDistanceLabel();

      genericTooltip.create($item.parent(), {
        id: tooltipId,
        text: wordings.geoloc_distance_error
      });

      if ($item.hasClass('is-disabled')) {
        genericTooltip.open(tooltipId);
      }

      $item.addClass('is-disabled');
    },
    refresh() {
      const storeSearchParameters = cookieManagement.getCookie('storedSearchParams') !== null ? JSON.parse(cookieManagement.getCookie('storedSearchParams')) : {};

      /* Update user location stored in cookie if it exists */
      this.userPosition = geoloc.getUserLocation();

      //fix js error on searchElasticModel L.1170 where multiparticipants[1] is undefined
      if (typeof storeSearchParameters.multiparticipants[1] === 'undefined' && GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B') {
        storeSearchParameters.multiparticipants[1] = {
          adults: 0,
          seniors: 0,
          ages: [],
          pets: 0
        };
      }

      dispatcher.trigger('searchView:updateTemporaryModel', storeSearchParameters);
      if (['Search', 'Country', 'Region', 'Destination'].includes(PAGE_SCRIPTS.page_template)) {
        this.model.set({sort: null}); // refresh resultList
        if (GLOBAL_SCRIPTS.ABTEST_COMPARATOR === 'B') {
          cookieManagement.createCookie('geoLocFirstEnable', true);
          $('.js-compareButton').click(); //refresh compare page distance labels
        }
      }
    },
    /**
     * Render label template
     * @param {number} value
     * @param {string} unit
     * @param {string} icon
     * @param {array} classNames
     */
    renderLabel({value, unit = 'km', icon = null, classNames = []}) {
      let classArray = cookieManagement.getCookie('userHideLocation') === 'true' ? ['geolocDistance', 'js-geolocDistance-label', 'u-Hidden--forced'] : ['geolocDistance', 'js-geolocDistance-label'] ;
      value = value ? Math.round(value) : 0;
      return value >= 1 ? `<span class="${classArray.concat(classNames).join(' ')}">${icon ? `<i class="icon icon-${icon}"></i>` : ''}${value}&nbsp;${unit}</span>` : '';
    }
  }
};
